import i18n from '@/configs/VueI18n'

export const payloadParams = (payload) => {
    if(payload) {
        let reqData = "";
        Object.keys(payload).forEach(key => {
            reqData += key + "=" + payload[key] + "&"
        })
        reqData = reqData.substr(0, reqData.lastIndexOf("&"))
        return '?'+reqData
    } else return ''
}

//Добавление интерполяции тенге
export const price = (price, color = '') => {
    return `<strong class="${ color }">${ new Intl.NumberFormat('ru-RU').format(price) }</strong> ${i18n.t('tenge')}`
}
